export enum SecuritySource {
  Public = 'public',
  Surveillance = 'surveillance'
}
